// src/config/api.js
//
// Central API configuration.
// Reads from .env (REACT_APP_API_BASE) if set; otherwise defaults to local dev.

const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://api.avtechbmt.cloud';

export const API_ROOT = API_BASE;
export const EXAMS_API = `${API_BASE}/api/exams`;
export const AUTH_API = `${API_BASE}/api/v1/auth`;
export const CONTACT_API = `${API_BASE}/api/contact`;
export const CANDIDATES_API = `${API_BASE}/api/candidates`;

export default API_BASE;